import { statusNameSpace, statusConstants } from "../constants/currentUser.constants";

const initialState = {
    loading: false,
    success: false,
    request: null,
    response: null,
    error: null,
};

export const getCurrentUserStatus = (state = initialState, action) => {
    switch (action.type) {
        case statusConstants[`GET_${statusNameSpace}_REQUEST`]:
            return {
                ...state,
                loading: true,
                request: action.request,
                error: null,
            };
        case statusConstants[`GET_${statusNameSpace}_SUCCESS`]:
            return {
                ...state,
                loading: false,
                success: true,
                response: action.response,
                error: null,
            };
        case statusConstants[`GET_${statusNameSpace}_FAILURE`]:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.error,
            };
        default:
            return state;
    }
};
